import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as Yup from 'yup';
import { EmployersNumEmployees, EmployersYourRole, EmployersIndustry, HowDidYouHearAboutUs } from '@yoweb/types/enums';
import hasFullWidthChars from '@yoweb/utils/intl/hasFullWidthChars';
import { assertIsString } from '@yoweb/utils/isString';
export var getInTouchForm = function getInTouchForm(t, _ref) {
  var localeHasFullWidthChars = _ref.localeHasFullWidthChars,
      lcLocale = _ref.lcLocale;
  var baseSchema = {
    firstName: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    },
    lastName: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    },
    companyName: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    },
    email: {
      defaultValue: '',
      validation: Yup.string().trim().test({
        message: t('validation.enter-half-width-characters'),
        test: function test(value) {
          return value && localeHasFullWidthChars ? !hasFullWidthChars(value) : true;
        }
      }).email(t('validation.enter-valid-address')).required(t('validation.required'))
    },
    howCanWeHelp: {
      defaultValue: '',
      validation: Yup.string().trim()
    },
    phoneNum: {
      defaultValue: '',
      validation: Yup.string().trim().required(t('validation.required'))
    }
  };

  if (lcLocale === 'ja-jp') {
    var japanSchema = {
      department: {
        defaultValue: '',
        validation: Yup.string().trim().required(t('validation.required'))
      },
      yourRole: {
        defaultValue: '',
        validation: Yup.string().trim().required(t('validation.required'))
      }
    };
    return _objectSpread(_objectSpread({}, baseSchema), japanSchema);
  } else if (lcLocale === 'en-us') {
    var usSchema = {
      industry: {
        defaultValue: '',
        validation: Yup.string().trim().required(t('validation.required'))
      },
      employees: {
        defaultValue: '',
        validation: Yup.string().trim().required(t('validation.required'))
      },
      howDidYouHearAboutUs: {
        defaultValue: '',
        validation: Yup.string().trim().required(t('validation.required'))
      }
    };
    return _objectSpread(_objectSpread({}, baseSchema), usSchema);
  }

  return baseSchema;
};
export var getNumEmployeesOptions = function getNumEmployeesOptions(t) {
  return [EmployersNumEmployees.LESS_THAN_ONE_HUNDRED, EmployersNumEmployees.UP_TO_FIVE_HUNDRED, EmployersNumEmployees.UP_TO_ONE_THOUSAND, EmployersNumEmployees.UP_TO_FIVE_THOUSAND, EmployersNumEmployees.MORE_THAN_FIVE_THOUSAND].map(function (option) {
    return {
      value: t("num-employees.options.".concat(option), {
        ns: 'employers-form'
      }),
      label: t("num-employees.options.".concat(option), {
        ns: 'employers-form'
      })
    };
  });
};
export var getYourRoleOptions = function getYourRoleOptions(t, locale) {
  var roleOptions = [EmployersYourRole.FOUNDER_CEO, EmployersYourRole.CHRO_CPO, EmployersYourRole.HR, EmployersYourRole.PEOPLE_OPERATIONS, EmployersYourRole.TOTAL_REWARDS, EmployersYourRole.EMPLOYER_BRAND, EmployersYourRole.MARKETING, EmployersYourRole.OTHER];

  if (locale === 'ja-jp') {
    roleOptions.splice(roleOptions.length - 1, 0, EmployersYourRole.HEAD_OF_DEPARTMENT);
    roleOptions.splice(roleOptions.length - 1, 0, EmployersYourRole.ADMIN_FACILITIES);
  }

  return roleOptions.map(function (option) {
    var value = t("your-role.options.".concat(option), {
      ns: 'employers-form'
    });
    var label = t("your-role.options.".concat(option), {
      ns: 'employers-form'
    });
    assertIsString(value);
    assertIsString(label);
    return {
      value: value,
      label: label
    };
  });
};
export var getYourRoleOptionsV2Japan = function getYourRoleOptionsV2Japan(t) {
  var roleOptions = [EmployersYourRole.EXECUTIVE, EmployersYourRole.OFFICER_MANAGER_BUSSINESS_CLASS, EmployersYourRole.MANAGER_DEPUTY_MANAGER_CLASS, EmployersYourRole.SECTION_MANAGER_SECTION_MANAGER_CLASS, EmployersYourRole.SUPERVISOR_GNEREAL_EMPLOYER_CLASS];
  return roleOptions.map(function (option) {
    var value = t("your-role.options.".concat(option), {
      ns: 'employers-form'
    });
    var label = t("your-role.options.".concat(option), {
      ns: 'employers-form'
    });
    assertIsString(value);
    assertIsString(label);
    return {
      value: value,
      label: label
    };
  });
};
export var getIndustryOptions = function getIndustryOptions(t) {
  return [EmployersIndustry.AGRICULTURE, EmployersIndustry.APPAREL, EmployersIndustry.BANKING, EmployersIndustry.BIOTECHNOLOGY, EmployersIndustry.CHEMICALS, EmployersIndustry.COMMUNICATIONS, EmployersIndustry.CONSTRUCTION, EmployersIndustry.CONSULTING, EmployersIndustry.EDUCATION, EmployersIndustry.ELECTRONICS, EmployersIndustry.ENERGY, EmployersIndustry.ENGINEERING, EmployersIndustry.ENTERTAINMENT, EmployersIndustry.ENVIRONMENTAL, EmployersIndustry.FAMILY_SERVICES, EmployersIndustry.FINANCE, EmployersIndustry.FOOD_AND_BEVERAGE, EmployersIndustry.GOVERNMENT, EmployersIndustry.HEALTHCARE, EmployersIndustry.HOME_SERVICES, EmployersIndustry.HOSPITALITY, EmployersIndustry.INSURANCE, EmployersIndustry.MACHINERY, EmployersIndustry.MANUFACTURING, EmployersIndustry.MEDIA, EmployersIndustry.NOT_FOR_PROFIT, EmployersIndustry.OTHER, EmployersIndustry.RECREATION, EmployersIndustry.RETAIL, EmployersIndustry.SHIPPING, EmployersIndustry.TECHNOLOGY, EmployersIndustry.TELECOMMUNICATIONS, EmployersIndustry.TRANSPORTATION, EmployersIndustry.UTILITIES, EmployersIndustry.WELL_BEING_SERVICES].map(function (option) {
    return {
      value: t("industry.options.".concat(option), {
        ns: 'employers-form'
      }),
      label: t("industry.options.".concat(option), {
        ns: 'employers-form'
      })
    };
  });
};
export var getHowDidYouHearAboutUsOptions = function getHowDidYouHearAboutUsOptions(t) {
  return [HowDidYouHearAboutUs.SEARCH, HowDidYouHearAboutUs.SOCIAL_MEDIA, HowDidYouHearAboutUs.LINKEDIN, HowDidYouHearAboutUs.MEDIA_NEWS, HowDidYouHearAboutUs.YOHANA_MEMBER, HowDidYouHearAboutUs.EVENT, HowDidYouHearAboutUs.WORD_OF_MOUTH, HowDidYouHearAboutUs.OTHER].map(function (option) {
    return {
      value: t("how-did-you-hear-about-us.options.".concat(option), {
        ns: 'employers-form'
      }),
      label: t("how-did-you-hear-about-us.options.".concat(option), {
        ns: 'employers-form'
      })
    };
  });
};
export default getInTouchForm;